export default __webpack_public_path__ + "static/media/tfte-logo-sm-trimmy.455f23ea.png";